
import { Sale } from "@/models/base";
import { SaleAwsDocument } from "@/models/base/sale-aws-document";
import { AWSFileService } from "@/services/aws-file-service";
import Vue from "vue";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import {SaleService} from "@/services";
import AppSaleEditAwsDocumentsOptionsModal from "./SaleEditAwsDocumentsOptionsModal.vue";

export default Vue.extend({
	data() {
		return {
			sending: false,
			allFiles: [] as SaleAwsDocument[],
			openedSettingsItem: null as null | SaleAwsDocument

		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		},
	},
	computed: {
		moduleId():MODULE {
			return MODULE.DOCUMENTENBEHEER;
		},
		hasModule():boolean {
			return AuthService.hasModule(this.moduleId);
		},
		highestDisplayOrder():number {
			let val = 0;
			for (let item of this.allFiles ) {
				if (item.DisplayOrder > val){
					val = item.DisplayOrder;
				}
			}
			return val;
		}
	},
	methods: {
		async download(file:SaleAwsDocument){
			if (!file.File) return;
			await AWSFileService.downloadFile(file.File.Token, file.File.Name);
		},
		async onFile(file:File){
			let doc = new SaleAwsDocument();
			doc.toUploadFile = file;
			doc.DisplayOrder = this.highestDisplayOrder + 1;
			doc = await SaleService.uploadDocument(this.sale, doc);
			this.allFiles.push(doc);
			this.sale.AWSDocuments = this.allFiles;
		},
		async removeFile(index:number){
			let result = await this.$wf.confirm(this.$ct("confirm-delete"), this.$t("common.yes"), this.$t("common.no"), this.$ct("common.warning"), "warning");
			if(!result) return;
			try{
				await SaleService.deleteDocument(this.sale, this.allFiles[index]);
				this.allFiles.splice(index, 1);
				this.sale.AWSDocuments = this.allFiles;
			}catch(err){
			}
		},
		close(){
			this.$emit("close");
		},
		canPreviewFile(file:SaleAwsDocument):boolean{
			if (!file.File) return false;
			if (["application/pdf","image/png","image/jpeg"].includes(file.File.ContentType)) return true;
			return false;
		},
		previewFile(file:SaleAwsDocument){
			if (file.File){
				AWSFileService.previewAwsFile(file.File);
				return;
			}
		},
		getDocName(file:SaleAwsDocument):string {
			if (file.File) {
				return file.File.Name;
			}
			return "<ERROR>";
		},
		async onSort(){
			let hasChanges = false;
			this.allFiles.forEach((item, i)=>{
				if (item.DisplayOrder != i) {
					hasChanges = true;
				}
				item.DisplayOrder = i;
				if (item.ID != 0 && this.sale.toUpdateFiles.indexOf(item) == -1){
					this.sale.toUpdateFiles.push(item);
				}
			});
			if (!hasChanges) return;
			await SaleService.updateDocuments(this.sale, this.allFiles);
			this.sale.AWSDocuments = this.allFiles;
		}
	},
	created(){
		let allFiles = [...this.sale.AWSDocuments, ...this.sale.UnprocessedFiles];
		this.allFiles = allFiles;
	},
	components: {
		AppMissingModule,
		AppFileUpload,
		AppSaleEditAwsDocumentsOptionsModal
	},
	i18nEx: {
		componentPrefix: "components.aws-documents"
	}
});
